<template>
    <div class="login-view">
        <div class="card">
			<div class="card-body">
				<div class="m-sm-4">
                    <p class="lead text-center">
                        填寫完成
                    </p>
                    
					<div class="text-start">
                        <p>
                            野灣野生動物保育協會，非常感謝您！<br>
                            我們已受理您的通報<br>
                            受理單編號:<strong>{{ serial_no }}</strong><br>
                            有任何問題歡迎來電。
                        </p>
                        <div class="text-center mt-3">
                            <button type="button"
                                @click="()=>{ $router.push('/createIntake') }"
                                class="btn btn-primary w-100"
                            >重新填寫受理單</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'reportSubmitted',
    data(){
        return {
            serial_no:this.$route.params.serial_no
        }
    },
    components: {
      
    },
    methods:{
        
    }
}
</script>
<style scoped>
.login-view{
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 使 ::before 绝对定位相对于这个容器 */
    background-image: url('@/assets/img/wildoneHis/clouded leopard LOGO.png');
    background-repeat: no-repeat;
    background-size: 20rem;
    background-position-x: 6rem;
    background-position-y: 5rem;

}
.login-view::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4); /* 白色半透明，調整 alpha 值以改變壓淡程度 */
    z-index: 1; /* 讓遮罩在背景圖片上 */
}

.content {
    position: relative; /* 使内容在遮罩之上 */
    z-index: 2;
}
.login-view > .card {
    min-width: 576px;
    max-width: 576px;
    height: fit-content;
    z-index:2;
}
.img-fluid{
    background-color: #f4f7fc;
}

@media (max-width: 768px) {
    .login-view{
        background-size: 18rem;
        background-position-x: center;
        background-position-y: 8rem;
    }
    .login-view > .card {
        min-width: 90%;
        max-width: 576px;
        height: fit-content;
        z-index:2;
    }
}
</style>
  